import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeContextProvider } from './ThemeContext';
import { ChatbotProvider } from './contexts/ChatbotContext'; // Import the provider
import { BrowserRouter} from "react-router-dom";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeContextProvider>
     <BrowserRouter>
      <ChatbotProvider> {/* Wrap the App */}
        <App />
      </ChatbotProvider>
      </BrowserRouter>
    </ThemeContextProvider>
);